import './MainPage.scss';

import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { useDataQuery, useGTMDataSend } from 'common/hooks';
import { PATH, RouteParams } from 'router';
import { cn } from 'ui/utils/bem';
import { ContentBuilder } from '../../../common/components/ContentBuilder/ContentBuilder';
import { queryHomePage } from 'network/api/home/queryHomePage';
import { useIntl } from 'react-intl';
import { useLetsTalkFormDictionary } from '../../../common/hooks/useLetsTalkFormDictionary';
import { useRedirect404 } from '../../../common/hooks/useRedirect404';
import { mutationMainForm } from 'network';

const cnMainPage = cn('MainPage');

type Props = RouteComponentProps<RouteParams> & {};

const MainPage: React.FC<Props> = ({ history }) => {
  const { locale } = useIntl();
  const { loading, data, error } = useDataQuery(queryHomePage, {
    locale,
  });

  const { dictionariesForm } = useLetsTalkFormDictionary();
  const { metaTitle, content, id } = data || {};

  useRedirect404(error, history);
  useGTMDataSend(metaTitle);

  return (
    <>
      {!loading && (
        <>
          <div className={cnMainPage()}>
            <ContentBuilder
              pageId={id}
              items={content}
              aliases={PATH}
              dictionariesForm={dictionariesForm}
              onSubmitForm={async body => await mutationMainForm({ body })}
            />
          </div>
        </>
      )}
    </>
  );
};

export default MainPage;
